const STORAGE_KEY = 'talecraft.pendingVoucherCode';

const hasBrowserStorage = (): boolean => typeof window !== 'undefined' && typeof window.localStorage !== 'undefined';

const withStorage = <T>(fallback: T, effect: (storage: Storage) => T): T => {
    if (!hasBrowserStorage()) {
        return fallback;
    }

    try {
        return effect(window.localStorage);
    } catch (error) {
        console.warn('Pending voucher storage error', error);
        return fallback;
    }
};

export const getPendingVoucher = (): string | null =>
    withStorage<string | null>(null, storage => storage.getItem(STORAGE_KEY));

export const setPendingVoucher = (code: string): void => {
    withStorage<void>(undefined, storage => {
        const normalized = code.trim();
        if (normalized.length === 0) {
            storage.removeItem(STORAGE_KEY);
            return;
        }

        storage.setItem(STORAGE_KEY, normalized);
    });
};

export const clearPendingVoucher = (): void => {
    withStorage<void>(undefined, storage => {
        storage.removeItem(STORAGE_KEY);
    });
};



